import {Component, React, observer, resolveCss} from '$src/handy'
import * as css from './Table.css'
import {ResearchStateTab, IStore} from '$src/bootstrap/Store'
import ReactTable, {Column} from 'react-table'
import {getSnapshot} from 'mobx-state-tree'
import HideColumnIcon from 'react-icons/lib/fa/close'
import {includes} from 'lodash'
import {DateTime} from 'luxon'
interface Props {
  css?: any
  activeTabState: typeof ResearchStateTab.Type
  setHoveredItemIds: (ids: {[id: number]: true}) => void
  hoveredItemIds: {[id: number]: true}
  setActiveItemIds: (ids: {[id: number]: true}) => void
  activeItemIds: {[id: number]: true}
  activeItemIdsArray: string[]
}

interface State {
  apiData: any[]
}

const classes = resolveCss(css, {})

@observer
export default class TableOfRentData extends Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context)
    this.state = {
      apiData: [],
    }
  }

  getTrProps = (
    _: unknown,
    row: {original: {id: number; selected: boolean}},
  ) => {
    if (!row) return {}
    const {original} = row

    return {
      onClick: () => {
        this.props.setActiveItemIds({[original.id]: true})
      },
      onMouseOver: () => {
        if (original.municipality) {
          this.props.setHoveredItemIds({[original.id]: true})
        }
      },
      ...classes(
        original.selected === true && 'enabled',
        this.props.activeItemIds[original.id] === true && 'activeRow',
        this.props.hoveredItemIds[original.id] === true && 'hoveredRow',
      ),
    }
  }

  render() {
    const {props} = this

    const foundItems = getSnapshot(props.activeTabState.foundItems)
    const {byId} = foundItems

    const list = foundItems.list
      .map((id: string) => ({
        ...byId[id],
        selected: foundItems.selectedIdsRent[id] === true,
      }))
      .filter((item: {dataType: string}) => item.dataType === 'rent')

    const markerlist = props.activeItemIdsArray.map((item: {id: string}) => ({
      ...byId[item.id],
      selected: foundItems.selectedIdsRent[item.id] === true,
    }))

    let rentList = []
    if (list.filter((item: any) => item.dataType === 'rent')) {
      rentList = list
        .filter((item: any) => item.dataType === 'rent')
        .map((rentItem: any) => {
          return rentItem
        })
    }

    const dataSource = markerlist.length > 0 ? markerlist : rentList

    return (
      <ReactTable
        className={css.table}
        data={dataSource}
        defaultFilterMethod={defaultFilterMethod}
        showPagination={true}
        getTrProps={this.getTrProps}
        loading={props.activeTabState.foundItems.queried !== true}
        defaultPageSize={rentList.length}
        pageSize={props.activeTabState.getSelectedPageSize() || 10}
        pageSizeOptions={[
          10,
          20,
          50,
          ...(rentList.length > 50 ? [rentList.length] : []),
        ]}
        onPageSizeChange={pageSize =>
          props.activeTabState.setSelectedPageSize(pageSize)
        }
        multiSort={false}
        style={{
          height: '110vh',
        }}
        columns={[
          {
            Header: '',
            accessor: 'selected',
            sortable: true,
            maxWidth: 40,
            className: css.disabledEnabledCell,
            Cell: ({original}) => {
              if (original.id) {
                return (
                  <label
                    className={css.checkBoxLabel}
                    onClick={e => e.stopPropagation()}
                    key={'checkbox-label-' + original.id}
                  >
                    <input
                      type="checkbox"
                      checked={original.selected}
                      key={'checkbox-' + original.id}
                      title="Hold ALT/OPTION to select/deselect other sales in the same address"
                      onChange={e => {
                        if (e.nativeEvent.altKey) {
                          props.activeTabState.batchSelectOrUnselectByAddressRent(
                            original.id,
                            !original.selected,
                          )
                        } else {
                          props.activeTabState.setSelectedForIdRent(
                            original.id,
                            !original.selected,
                          )
                        }
                      }}
                    />
                  </label>
                )
              } else {
                return null
              }
            },
          },
          {
            Header: ColumnHeader('Property type'),
            accessor: 'propertyType',
            sortable: true,
            filterable: true,
            Cell: ({original}) => {
              if (original.propertyType) {
                return format(original.propertyType, original)
              } else {
                return null
              }
            },
          },
          {
            Header: ColumnHeader('Accommodation type'),
            accessor: 'accommodationType',
            sortable: true,
            filterable: true,
            Cell: ({original}) => {
              if (original.accommodationType) {
                return format(original.accommodationType, original)
              } else {
                return null
              }
            },
          },
          {
            Header: ColumnHeader('Living area'),
            accessor: 'livingArea',
            sortable: true,
            filterable: true,
            Cell: ({original}) => {
              if (original.livingArea) {
                return format(original.livingArea, original)
              } else {
                return null
              }
            },
          },
          {
            Header: ColumnHeader('Year of construction'),
            accessor: 'yearOfConstruction',
            sortable: true,
            filterable: true,
            Cell: ({original}) => {
              if (original.yearOfConstruction) {
                return format(original.yearOfConstruction, original)
              } else {
                return null
              }
            },
          },
          {
            Header: ColumnHeader('Date of Rent Observation'),
            accessor: 'dateOfRent',
            sortable: true,
            filterable: true,
            sortMethod: (a: string, b: string) => {
              const aT = DateTime.fromISO(a)
              const bT = DateTime.fromISO(b)
              return aT > bT ? 1 : aT < bT ? -1 : 0
            },
            Cell: ({original}: {original: $FixMe}) => {
              if (original.dateOfRent) {
                return DateTime.fromISO(original.dateOfRent).toFormat(
                  'dd.LL.yyyy',
                )
              } else {
                return null
              }
            },
          },
          {
            Header: ColumnHeader('# of rooms'),
            accessor: 'numberOfRooms',
            sortable: true,
            filterable: true,
            Cell: ({original}) => {
              if (original.numberOfRooms) {
                return format(original.numberOfRooms, original)
              } else {
                return null
              }
            },
          },
          {
            Header: ColumnHeader('Condition'),
            accessor: 'condition',
            sortable: true,
            filterable: true,
            Cell: ({original}) => {
              if (original.condition) {
                return format(original.condition, original)
              } else {
                return null
              }
            },
          },
          {
            Header: ColumnHeader('Has sauna'),
            accessor: 'hasSauna',
            sortable: true,
            filterable: true,
            Cell: ({original}) => {
              if (original.hasSauna) {
                return format(original.hasSauna, original)
              } else if (original.id) {
                return 'No'
              } else {
                return null
              }
            },
          },
          {
            Header: ColumnHeader('Rooms description'),
            accessor: 'roomsDescription',
            sortable: true,
            filterable: true,
            Cell: ({original}) => {
              if (original.roomsDescription) {
                return format(original.roomsDescription, original)
              } else {
                return null
              }
            },
          },
          {
            Header: ColumnHeader('Floor number'),
            accessor: 'floorNumber',
            sortable: true,
            filterable: true,
            Cell: ({original}) => {
              if (original.floorNumber) {
                return format(original.floorNumber, original)
              } else {
                return null
              }
            },
          },
          {
            Header: ColumnHeader('Rent price'),
            accessor: 'rent',
            sortable: true,
            filterable: true,
            Cell: ({original}) => {
              if (original.rent) {
                return format(original.rent, original)
              } else {
                return null
              }
            },
          },
          {
            Header: ColumnHeader('Rent price sqm'),
            accessor: 'rentSqm',
            sortable: true,
            filterable: true,
            Cell: ({original}) => {
              if (original.rentSqm) {
                return format(original.rentSqm, original)
              } else {
                return null
              }
            },
          },
          {
            Header: ColumnHeader('Municipality'),
            accessor: 'municipality',
            sortable: true,
            filterable: true,
            Cell: ({original}) => {
              if (original.municipality) {
                return format(original.municipality, original)
              } else {
                return null
              }
            },
          },
          {
            Header: ColumnHeader('Postal code'),
            accessor: 'postalCode',
            sortable: true,
            filterable: true,
            Cell: ({original}) => {
              if (original.postalCode) {
                return format(original.postalCode, original)
              } else {
                return null
              }
            },
          },
          {
            Header: ColumnHeader('Street address'),
            accessor: 'streetAddress',
            sortable: true,
            filterable: true,
            Cell: ({original}) => {
              if (original.streetAddress) {
                return format(original.streetAddress, original)
              } else {
                return null
              }
            },
          },
          {
            Header: ColumnHeader('Owner'),
            accessor: 'owner',
            sortable: true,
            filterable: true,
            Cell: ({original}) => {
              if (original.owner) {
                return format(original.owner, original)
              } else {
                return null
              }
            },
          },
          {
            Header: ColumnHeader('Source'),
            accessor: 'source',
            sortable: true,
            filterable: true,
            Cell: ({original}) => {
              if (original.source) {
                return format(original.source, original)
              } else {
                return null
              }
            },
          },
          {
            Header: ColumnHeader('Location'),
            accessor: 'location',
            store: this.store,
            width: 90,
            sortable: true,
            filterable: true,
            Cell: ({original}) => {
              if (original.location) {
                return (
                  <div className={css.location}>
                    <div className={css.pair}>
                      <span>
                        {parseFloat(original.location.lat).toFixed(6)}
                      </span>
                      <span>
                        {parseFloat(original.location.long).toFixed(6)}
                      </span>
                    </div>
                  </div>
                )
              } else {
                return null
              }
            },
          },
        ]}
      />
    )
  }
}

const format = (s: unknown, opts: {toFixed?: number}) =>
  typeof s === 'string'
    ? s
    : typeof s === 'number'
    ? typeof opts.toFixed === 'number'
      ? s.toFixed(opts.toFixed)
      : s
    : typeof s === 'boolean'
    ? s
      ? 'Yes'
      : 'No'
    : s === null
    ? 'Unkown'
    : s === undefined
    ? 'Unkown'
    : JSON.stringify(s)

const ColumnHeader = (headerText: string) => ({
  column,
}: {
  column: {store: IStore; id: string}
}) => {
  const store = column.store

  return (
    <div className={css.columnHeader}>
      {headerText}
      <div
        className={css.columnHeaderCloseButton}
        onClick={() => {
          store.hiddenColumnsInComparableSalesView.add(column.id)
        }}
      >
        <HideColumnIcon />
      </div>
    </div>
  )
}

export const defaultFilterMethod = (filter: any, row: any, column: Column) => {
  const id = filter.pivotId || filter.id
  return row[id] !== undefined
    ? includes(String(row[id]).toLowerCase(), filter.value.toLowerCase())
    : true
}

export function booleanFilterMethod(accessor: string) {
  return (filter: $FixMe, row: $FixMe) => {
    if (typeof filter.value !== 'string' || filter.value.length === 0)
      return true
    if (filter.value[0].toLowerCase() === 'y') {
      return row[accessor] === true
    }
    if (filter.value[0].toLowerCase() === 'n') {
      return row[accessor] === false
    }
    return true
  }
}



// WEBPACK FOOTER //
// ./src/comparableSales/TableOfRentData.tsx